





import React, { useState, useEffect } from "react";
import {
  Box,
  Typography,
  Grid,
  // Button,
  Paper,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  tableCellClasses,
  Divider,
} from "@mui/material";
import { FiDownload } from "react-icons/fi";
import { Add } from "@mui/icons-material";
import { FontFamily } from "assets";
import { v4 as uuidv4 } from "uuid";
import { useForm } from "react-hook-form";
import styled from "@emotion/styled";
import InputField from "components/Input";
import instance from "config/axios";
import routes from "services/System/routes";
import InputPhone from "components/InputPhone";
import { emailRegex } from "utils";
import Colors from "assets/Style/Colors";
import { PrimaryButton } from "components/Buttons";
import { SuccessToaster, ErrorToaster } from "components/Toaster";
import DatePicker from "components/DatePicker";
import SupplierServices from "services/Supplier";
// import CheckIcon from "@mui/icons-material/Check";
// import EditIcon from "@mui/icons-material/Edit";
import { CleanTypes, getFileSize } from "utils";
import SelectField from "components/Select";
import UploadFile from "components/UploadFile";
import BankServices from "services/Bank";
import { useNavigate } from "react-router-dom";

const CustomPaper = styled(Paper)(({ theme }) => ({
  gap: 0,
}));

const Row = styled(TableRow)(({ theme }) => ({
  border: 0,
}));

const Cell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    border: 0,
    textAlign: "left",
    whiteSpace: "nowrap",
    backgroundColor: Colors.primary,
    color: Colors.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    fontFamily: FontFamily.NunitoRegular,
    textAlign: "left",
    textWrap: "nowrap",

    ".MuiBox-root": {
      display: "flex",
      gap: "6px",
      alignItems: "center",
      justifyContent: "center",
      ".MuiBox-root": {
        cursor: "pointer",
      },
    },
    svg: {
      width: "auto",
      height: "24px",
    },
    ".MuiTypography-root": {
      textTransform: "capitalize",
      fontFamily: FontFamily.NunitoRegular,
      textWrap: "nowrap",
    },
    ".css-1ru1j9e-MuiTableCell-root ": {
      color: "#ffffff",
      textAlign: "left",
    },
    ".MuiButtonBase-root": {
      padding: "8px",
      width: "28px",
      height: "28px",
    },
  },
}));

// Helper: red border style for invalid fields
const errorBorderSx = {
  "& .MuiOutlinedInput-root": {
    "& fieldset": { borderColor: "red" },
    "&:hover fieldset": { borderColor: "red" },
    "&.Mui-focused fieldset": { borderColor: "red" },
  },
  "& .MuiInputLabel-root": { color: "red" },
};

function SupplierOnBoarding() {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    resetField,
    control,

  } = useForm();

  const navigate = useNavigate();
  const [activeStep, setActiveStep] = useState(0);
  const [loader, setLoader] = useState(false);
  const [licenseDate, setLicenseDate] = useState(new Date());
  const [selectedDocumentType, setSelectedDocumentType] = useState("");
  const [selectedBank, setSelectedBank] = useState("");
  const [banks, setBanks] = useState([]);
  const [documentList, setDocumentList] = useState([]);
  const [documentLink2, setDocumentLink2] = useState("");
  const [progress2, setProgress2] = useState(0);
  const [uploadedSize2, setUploadedSize2] = useState(0);
  const [documentDetail2, setDocumentDetail2] = useState([]);
  const [code, setCode] = useState(null);
  const [isDocumentSelected, setIsDocumentSelected] = useState(false);
  const [isDocumentUploaded, setIsDocumentUploaded] = useState(false);
  const [emailValue, setEmailValue] = useState("");
  const [vatTaxValue, setVatTaxValue] = useState("");
  const [amountAedValue, setAmountAedValue] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [tradeLicense, setTradeLicense] = useState("");
  const [bankAccounts, setBankAccounts] = useState([]);
  const [selectedBankAccount, setSelectedBankAccount] = useState(null);
const [showDraftErrors, setShowDraftErrors] = useState(false);
  // ─── Validation highlight states ───────────────────────────────────────────
  const [showStep0Errors, setShowStep0Errors] = useState(false);
  const [showStep1Errors, setShowStep1Errors] = useState(false);
  const [showStep2Errors, setShowStep2Errors] = useState(false);

  // Derived booleans for each required field
  const step0AuthorizePersonError = showStep0Errors && !getValues("authorizePerson");
  const step0CompanyError = showStep0Errors && !companyName;
  const step0EmailError = showStep0Errors && !emailValue;
  const step0PhoneError = showStep0Errors && !getValues("phone");

  const step1VatTaxError = showStep1Errors && !vatTaxValue;

  const step2BankError = showStep2Errors && !selectedBankAccount;
  const step2IbanError = showStep2Errors && !getValues("iban");
  const step2CreditDaysError = (showStep2Errors || showDraftErrors) && !getValues("creditDays");
  const step2AmountError = (showStep2Errors || showDraftErrors) && !amountAedValue;


  // const step2CreditDaysError = (showStep2Errors || showDraftErrors) && !getValues("creditDays");
// const step2AmountError = (showStep2Errors || showDraftErrors) && !amountAedValue;


  // ───────────────────────────────────────────────────────────────────────────
  const [uploadedFileName, setUploadedFileName] = useState("");

  const stepRequiredFields = {
    0: ["authorizePerson", "masterEmail", "phone"],
    1: ["vatTax"],
  }; const handleNext = () => {
  if (activeStep < 2) setActiveStep(activeStep + 1);
};
// const handleNext = () => {
//   if (activeStep === 0) {
//     if (!companyName || !getValues("authorizePerson") || !emailValue || !getValues("phone")) {
//       setShowStep0Errors(true);
//       ErrorToaster("Please fill all required fields before proceeding.");
//       return;
//     }
//     setShowStep0Errors(false);
//   }
//   if (activeStep === 1) {
//     if (!vatTaxValue) {
//       setShowStep1Errors(true);
//       ErrorToaster("Please fill all required fields before proceeding.");
//       return;
//     }
//     setShowStep1Errors(false);
//   }
//   if (activeStep < 2) setActiveStep(activeStep + 1);
// };
  const allowFilesTypeInvoice = [
    // "image/png",
    // "image/jpg",
    // "image/jpeg",
    "application/pdf",
  ];
  const handleUploadDocumentInvoices = async (e) => {
    try {
      e.preventDefault();

      setIsDocumentSelected(true);
      setIsDocumentUploaded(false);
      setUploadedFileName("");
      const file = e.target.files[0];

      setUploadedFileName(file?.name);
      let arr = [
        {
          id: uuidv4(),
          name: file?.name,
          file: "",
          type: file?.type.split("/")[1],
          size: getFileSize(file.size),
          isUpload: false,
        },
      ];
      if (allowFilesTypeInvoice.includes(file.type)) {
        setDocumentDetail2(arr);
        handleUploadInvoices(file, arr);
      } else {
        ErrorToaster(
          `Only ${CleanTypes(allowFilesTypeInvoice)} formats is supported`,
        );
        e.target.value = "";
        setUploadedFileName("");
        setIsDocumentSelected(false);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleUploadInvoices = async (file, docs) => {
    setProgress2(0);
    try {
      const formData = new FormData();
      formData.append("document", file);
      const { data } = await instance.post(routes.uploadDocuments, formData, {
        onUploadProgress: (progressEvent) => {
          const uploadedBytes = progressEvent.loaded;
          const percentCompleted = Math.round(
            (uploadedBytes * 100) / progressEvent.total,
          );

          setProgress2(percentCompleted);
          setUploadedSize2(getFileSize(uploadedBytes));
        },
      });
      if (data) {
        docs[0].isUpload = true;
        docs[0].file = data?.data?.nations;
        setDocumentDetail2(docs);
        setDocumentLink2(data?.data?.nations);
        SuccessToaster("Document Uploaded");
        setIsDocumentUploaded(true);
      }
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const handleAddDocument = () => {
    if (!documentLink2) {
      ErrorToaster("Please upload a document before adding.");
      return;
    }

    if (!selectedDocumentType?.id)
      return ErrorToaster("Please enter document Type");
    setDocumentList((prev) => [
      ...prev,
      {
        id: uuidv4(),
        doc_id: selectedDocumentType?.id,
        docType: selectedDocumentType?.name,
        documentLink2,
      },
    ]);
    SuccessToaster("Document Added");
    setSelectedDocumentType([]);
    setDocumentLink2("");
    setUploadedFileName("");
  };

  const handleLicenseDate = (newDate) => {
    try {
      if (newDate == "Invalid Date") {
        setLicenseDate("invalid");
        return;
      }
      setLicenseDate(new Date(newDate));
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const getBanks = async () => {
    try {
      let params = {
        page: 1,
        limit: 500,
      };
      const { data } = await BankServices.getBanks(params);
      setBankAccounts(data?.banks?.rows);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  const downloadAllAttachments = async (documentLinks) => {
    if (!documentLinks || documentLinks.trim() === "") {
      ErrorToaster("No attachments available.");
      return;
    }

    const filePath = documentLinks.trim();
    const fileUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}${filePath}`;
    const fileExtension = filePath.split(".").pop();

    try {
      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.setAttribute("download", `attachment.${fileExtension}`);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      window.URL.revokeObjectURL(blobUrl); // Cleanup
      SuccessToaster("Downloading attachment...");
    } catch (error) {
      console.error("Download failed", error);
      ErrorToaster("Failed to download attachment.");
    }
  };

  // Form submission handlers
  const buildSupplierPayload = ({ isDraft }) => {
    return {
      company_name: companyName,
      authorized_person: getValues("authorizePerson"),
      email: emailValue,
      phone: getValues("phone"),
      remarks: getValues("remarks"),
      trade_license_no: tradeLicense,
      trade_license_expiry: licenseDate,
      vat_tax: vatTaxValue,
      bank_name: selectedBankAccount ? selectedBankAccount.name : "",
      bank_iban: getValues("iban"),
      amount: amountAedValue,
      credit_days: getValues("creditDays"),
      supplier_documents: documentList.map((d) => ({
        doc_id: d.doc_id,
        invoice_attachment: d.documentLink2,
      })),
      is_draft: Boolean(isDraft),
    };
  };

const submitSupplier = async ({ isDraft }) => {
if (isDraft) {
    if (!getValues("creditDays") || !amountAedValue || Number(amountAedValue) <= 0) {
        if (Number(amountAedValue) <= 0) {
            ErrorToaster("Amount must be greater than 0."); 
        } else {
            ErrorToaster("Please enter Credit Days and Credit Limit to save draft.");
        }
        setShowDraftErrors(true);
        setActiveStep(2);
        return;
    }
}

  if (!isDraft) {
    // Step 0
    if (!companyName || !getValues("authorizePerson") || !emailValue || !getValues("phone")) {
      setShowStep0Errors(true);
      setActiveStep(0);
      ErrorToaster("Please fill all required fields in Company Info.");
      return;
    }
    setShowStep0Errors(false);

    // Step 1
    if (!vatTaxValue) {
      setShowStep1Errors(true);
      setActiveStep(1);
      ErrorToaster("Please fill all required fields in License & Tax Info.");
      return;
    }
    setShowStep1Errors(false);

    // Step 2
 if (!selectedBankAccount || !getValues("iban") || !amountAedValue || Number(amountAedValue) <= 0 || !getValues("creditDays")) {
    if (Number(amountAedValue) <= 0) {
        ErrorToaster("Amount must be greater than 0."); 
    } else {
        ErrorToaster("Please fill all required fields in Bank Info.");
    }
    setShowStep2Errors(true);
    setActiveStep(2);
    return;
}
    setShowStep2Errors(false);
  }

  setLoader(true);
  try {
    const payload = buildSupplierPayload({ isDraft });
    const response = await SupplierServices.addSupplier(payload);
    if (response?.responseCode === 200) {
      SuccessToaster(isDraft ? "Draft saved successfully." : "Supplier added successfully.");
      navigate("/supplier-listing");
    } else {
      ErrorToaster(isDraft ? "Failed to save draft." : "Failed to add supplier.");
    }
  } catch (error) {
    ErrorToaster(error);
    console.error("Submit error:", error);
  } finally {
    setLoader(false);
  }
};
  const handleSaveDraft = async () => {
    await submitSupplier({ isDraft: true });
  };

  const handleSubmitForm = async () => {
    await submitSupplier({ isDraft: false });
  };


  useEffect(() => {
    getBanks();
  }, []);

  // Function to render the form based on active step
  const renderForm = () => {
    switch (activeStep) {
      case 0:
        return (
          <>
            <Typography
              sx={{
                fontFamily: FontFamily.Halvetica,
                fontSize: "22px",
                fontWeight: 700,
                fontStyle: "Bold",
                mb: 1.5,
              }}
            >
              Company Info
            </Typography>

            <Grid container spacing={1}>
              {/* Company Info Form */}
              <Grid item xs={12} sm={6}>
                <InputField
                  size={"small"}
                  label={"Company Name"}
                  placeholder={"Company Name*"}
               
                  register={register("companyName", {
                     required: "Company name is required.",
                    onChange: (e) => setCompanyName(e.target.value),
                  })}
                   error={errors?.companyName?.message || (step0CompanyError ? "Company Name is required." : "")}
                  sx={step0CompanyError ? errorBorderSx : {}}
                  value={companyName}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputField
                  size={"small"}
                  label={"Authorized Person*"}
                  placeholder={"Enter Authorized Person"}
                  register={register("authorizePerson", {
                    required: "Authorize person name is required.",
                  })}
                  error={errors?.authorizePerson?.message || (step0AuthorizePersonError ? "Authorized Person is required." : "")}
                  sx={step0AuthorizePersonError ? errorBorderSx : {}}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputField
                  size={"small"}
                  label={"Email*"}
                  type="email"
                  placeholder={"Email"}
                  error={errors?.masterEmail?.message || (step0EmailError ? "Email is required." : "")}
                  register={register("masterEmail", {
                    required: "Please enter your email.",
                    pattern: {
                      value: emailRegex,
                      message: "Please enter a valid email.",
                    },
                    onChange: (e) => setEmailValue(e.target.value),
                  })}
                  value={emailValue}
                  sx={step0EmailError ? errorBorderSx : {}}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <Box
                  sx={
                    step0PhoneError
                      ? {
                        "& .react-tel-input .form-control": {
                          borderColor: "red !important",
                        },
                        "& .react-tel-input .flag-dropdown": {
                          borderColor: "red !important",
                        },
                        "& label": { color: "red" },
                      }
                      : {}
                  }
                >
                  <InputPhone
                    label="Phone*"
                    name="phone"
                    control={control}
                    size={"small"}
                    error={errors?.phone?.message || (step0PhoneError ? "Phone number is required." : "")}
                    onBlur={(e, v) => {
                      if (v && v.dialCode) {
                        setCode(v.dialCode);
                      } else {
                        console.error("Dial code is undefined");
                      }
                    }}
                    rules={{
                      required: "Please enter your phone number.",
                    }}
                    borderRadius="12px"
                    height="45px"
                  />
                </Box>
                {step0PhoneError && (
                  <Typography sx={{ color: "red", fontSize: "12px", mt: 0.5, ml: 1.5 }}>

                  </Typography>
                )}
              </Grid>

              <Grid item xs={12} sm={6}>
                <InputField
                  label={"Remarks"}
                  placeholder={"Enter remarks here..."}
                  register={register("remarks")}
                  multiline={true}
                  rows={3}
                />
              </Grid>
            </Grid>
          </>
        );
      case 1:
        return (
          <>
            <Typography
              sx={{
                fontFamily: FontFamily.Halvetica,
                fontSize: "22px",
                fontWeight: 700,
                fontStyle: "Bold",
                mb: 1.5,
              }}
            >
              License & Tax Info Form
            </Typography>
            <Grid container spacing={1}>
              {/* Company Info Form */}
              <Grid item xs={12} sm={6}>
                <InputField
                  size={"small"}
                  label={"Trade License"}
                  placeholder={"Enter Trade License"}
                  error={errors?.tradeLicense?.message}
                  register={register("tradeLicense", {
                    onChange: (e) => setTradeLicense(e.target.value),
                  })}
                  value={tradeLicense} // Ensure value is correctly mapped
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <DatePicker
                  minDate={new Date()}
                  label={"Trade License Expiry"}
                  size="small"
                  value={licenseDate}
                  onChange={handleLicenseDate}
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <InputField
                  size={"small"}
                  label={"VAT/TAX*"}
                  placeholder={"VAT/TAX*"}
                  error={errors?.shortName?.message || (step1VatTaxError ? "VAT/TAX is required." : "")}
                  register={register("vatTax", {
                    // required: "VAT/TAX is required.",
                    onChange: (e) => setVatTaxValue(e.target.value),
                  })}
                  value={vatTaxValue}
                  sx={step1VatTaxError ? errorBorderSx : {}}
                />
              </Grid>
              <Grid item xs={12} sm={6}></Grid>
              <Grid item xs={12} sm={3}>
                <SelectField
                  label="Document Type"
                  options={[
                    {
                      id: 1,
                      name: "Trade License",
                    },
                    {
                      id: 2,
                      name: "TAX Certificate",
                    },
                  ]}
                  selected={selectedDocumentType}
                  onSelect={(value) => {
                    setSelectedDocumentType(value);
                  }}
                  register={register("periodicInvoice", {
                    // required: "Please select invoice.",
                  })}
                />
              </Grid>

              <Grid item xs={10} sm={3} mt={3.7}>

                <UploadFile
                  key={uploadedFileName + documentList.length}
                  custom={true}
                  vendor={true}
                  style={{
                    backgroundColor: "#e7efeb",
                    width: "100%",
                    height: "40px",
                    display: "flex",
                    justifyContent: "space-between",
                    padding: "10px 8px",
                    wordBreak: "break-word",
                    border: "1px dashed #aeb1b0",
                    borderRadius: "10px",
                  }}
                  register={register("scanned", {
                    onChange: (e) => handleUploadDocumentInvoices(e),
                  })}
                />
                {uploadedFileName && (
                  <Typography
                    sx={{
                      fontSize: "12px",
                      color: Colors.primary,
                      mt: 0.8,
                      ml: 0.5,
                      wordBreak: "break-all",
                    }}
                  >
                    📄 {uploadedFileName}
                  </Typography>)}
              </Grid>
              <Grid item xs={2} sm={1} sx={{ textAlign: "right" }} mt={4}>
                <IconButton
                  size="small"
                  onClick={handleAddDocument}
                  sx={{
                    bgcolor: Colors.primary,
                    color: Colors.white,
                    "&:hover": {
                      bgcolor: Colors.primary,
                      color: Colors.white,
                    },
                  }}
                >
                  <Add />
                </IconButton>
              </Grid>
              {documentList.length > 0 ? (
                <>
                  <Grid item xs={12} sm={12}>
                    <TableContainer component={Paper}>
                      <Table
                        sx={{ minWidth: 650 }}
                        aria-label="Documents Table"
                      >
                        <TableHead
                          sx={{
                            bgcolor: Colors.primary,
                            color: Colors.white,
                          }}
                        >
                          <TableRow>
                            <Cell>Document Type</Cell>
                            <Cell>Attachment</Cell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {documentList.map((doc) => (
                            <TableRow key={doc?.id}>
                              <TableCell>{doc?.docType}</TableCell>
                              <TableCell>
                                {doc?.documentLink2 && doc?.documentLink2 ? (
                                  <div
                                    style={{ cursor: "pointer", marginLeft: "14px" }}
                                    onClick={() =>
                                      downloadAllAttachments(doc?.documentLink2)
                                    }
                                  >
                                    <FiDownload
                                      color={Colors.primary}
                                      size={25}
                                    />
                                  </div>
                                ) : (
                                  <FiDownload color="gray" size={25} />
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  </Grid>
                </>
              ) : (
                <></>
              )}
            </Grid>
          </>
        );
      case 2:
        return (
          <>
            <Typography
              sx={{
                fontFamily: FontFamily.Halvetica,
                fontSize: "22px",
                fontWeight: 700,
                fontStyle: "Bold",
                mb: 1.5,
              }}
            >
              Bank Info
            </Typography>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6}>
                <Box
                  sx={
                    step2BankError
                      ? {
                        "& .MuiOutlinedInput-root fieldset": { borderColor: "red" },
                        "& .MuiInputLabel-root": { color: "red" },
                      }
                      : {}
                  }
                >
                  <SelectField
                    size={"small"}
                    label={"Bank Account"}
                    options={bankAccounts}
                    selected={selectedBankAccount}
                    onSelect={(value) => {
                      setSelectedBankAccount(value);
                      setValue("iban", value?.account_ibn);
                    }}
                    error={step2BankError ? "Please select bank account." : errors?.bank?.message}
                    register={register("bank", {
                      required: "Please select bank account.",
                    })}
                  />
                </Box>
             
              </Grid>

              {/* Company Info Form */}
              <Grid item xs={12} sm={6}>
                <InputField
                  size={"small"}
                  label={"IBAN*"}
                  placeholder={"Enter IBAN"}
                  // value={selectedBankAccount?.account_ibn}
                  register={register("iban", {
                    required: "IBAN is required.",
                  })}
                  error={errors?.iban?.message || (step2IbanError ? "IBAN is required." : "")}
                  sx={step2IbanError ? errorBorderSx : {}}
                  disabled={true}
                />
              </Grid>
 <Grid item xs={12} sm={6}>
                                <InputField
                                    size={"small"}
                                    label={"Amount (AED)"}
                                    placeholder={"Enter Amount AED"}
                                     value={amountAedValue}
                                    register={register("amountAed", {
                                        required: "Amount Required",
                                        onChange: (e) => {
                                            let v = e.target.value;
                                            v = v.replace(/,/g, "");
                                            v = v.replace(/[^0-9.]/g, "");
                                            const parts = v.split(".");
                                            if (parts.length > 2) v = parts[0] + "." + parts[1];
                                            if (parts[1]?.length > 2) v = parts[0] + "." + parts[1].slice(0, 2);
                                            if (v !== "" && Number(v) <= 0) {
                                                ErrorToaster("Amount must be greater than 0.");
                                                return;
                                            }
                                            e.target.value = v;
                                            setAmountAedValue(v);
                                        },
                                    })}
                                    error={errors?.amountAed?.message || (step2AmountError ? "Amount is required." : "")}
                                    sx={step2AmountError ? errorBorderSx : {}}
                                />
                            </Grid>

              <Grid item xs={12} sm={6}>
                <InputField
                  size={"small"}
                  label={"Credit Days*"}
                  placeholder={"Enter Credit Days"}
                  register={register("creditDays", {
                    required: "Credit Days is required.",
                  })}
                  error={errors?.creditDays?.message || (step2CreditDaysError ? "Credit Days is required." : "")}
                  sx={step2CreditDaysError ? errorBorderSx : {}}
                />
              </Grid>
            </Grid>
          </>
        );
      default:
        return <Typography>Select a form to fill</Typography>;
    }
  };

  return (
    <Box sx={{ m: 4, mb: 8 }}>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          mb: 4,
          mt: 4,
        }}
      >
        <Typography
          variant="h5"
          sx={{
            color: "#094526",
            fontFamily: FontFamily.Halvetica,
            fontSize: "32px",
            fontWeight: 700,
            fontStyle: "Bold",
          }}
        >
          Supplier Onboarding
        </Typography>
      </Box>

      <Grid container spacing={2}>
        <Grid item xs={12} md={3.5}>
          <CustomPaper
            sx={{
              borderRadius: "6px",
              border: `1px solid ${Colors.grey}`,
              display: "flex",
              flexDirection: "column",
              gap: 2,
              padding: "0px !important",
              margin: "0px !important",
            }}
          >
            <Box
              sx={{
                padding: "0px !important",
                borderLeft:
                  activeStep === 0 ? "6px solid #5BBC0F" : "transparent",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  marginTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <IconButton
                  sx={{
                    backgroundColor:
                      activeStep === 0 ? "transparent" : "transparent",
                    color: activeStep === 0 ? "#5BBC0F" : Colors.grey,
                    border: "1px solid",
                    borderColor: activeStep === 0 ? "#5BBC0F" : Colors.grey,
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    padding: 1,
                    marginLeft: "20px",
                  }}
                  onClick={() => setActiveStep(0)}
                >
                  <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
                    01
                  </Typography>
                </IconButton>
                <Typography
                  sx={{
                    color: activeStep === 0 ? "#5BBC0F" : Colors.grey,
                    fontWeight: 700,
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  onClick={() => setActiveStep(0)}
                >
                  Company Info
                </Typography>
              </Box>
            </Box>

            <Divider sx={{ borderColor: Colors.grey }} />

            <Box
              sx={{
                borderLeft:
                  activeStep === 1 ? "6px solid #5BBC0F" : "transparent",
                padding: "0px !important",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  marginTop: "15px",
                  marginBottom: "15px",
                }}
              >
                <IconButton
                  sx={{
                    backgroundColor:
                      activeStep === 1 ? "transparent" : "transparent",
                    color: activeStep === 1 ? "#5BBC0F" : Colors.grey,
                    border: "1px solid",
                    borderColor: activeStep === 1 ? "#5BBC0F" : Colors.grey,
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    padding: 1,
                    marginLeft: "20px",
                  }}
                  onClick={() => setActiveStep(1)}
                >
                  <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
                    02
                  </Typography>
                </IconButton>
                <Typography
                  sx={{
                    color: activeStep === 1 ? "#5BBC0F" : Colors.grey,
                    fontWeight: 700,
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  onClick={() => setActiveStep(1)}
                >
                  License & Tax Info
                </Typography>
              </Box>
            </Box>

            <Divider
              sx={{ borderColor: Colors.grey, margin: "0px !important" }}
            />

            <Box
              sx={{
                borderLeft:
                  activeStep === 2 ? "6px solid #5BBC0F" : "transparent",
                padding: "0px !important",
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 2,
                  marginBottom: "15px",
                  marginTop: "15px",
                }}
              >
                <IconButton
                  sx={{
                    backgroundColor:
                      activeStep === 2 ? "transparent" : "transparent",
                    color: activeStep === 2 ? "#5BBC0F" : Colors.grey,
                    border: "1px solid",
                    borderColor: activeStep === 2 ? "#5BBC0F" : Colors.grey,
                    borderRadius: "50%",
                    width: "40px",
                    height: "40px",
                    padding: 1,
                    marginLeft: "20px",
                  }}
                  onClick={() => setActiveStep(2)}
                >
                  <Typography sx={{ fontWeight: 700, fontSize: "16px" }}>
                    03
                  </Typography>
                </IconButton>
                <Typography
                  sx={{
                    color: activeStep === 2 ? "#5BBC0F" : Colors.grey,
                    fontWeight: 700,
                    fontSize: "16px",
                    cursor: "pointer",
                  }}
                  onClick={() => setActiveStep(2)}
                >
                  Bank Info
                </Typography>
              </Box>
            </Box>
          </CustomPaper>
        </Grid>

        <Grid item xs={12} md={8}>
          {renderForm()}
        </Grid>
      </Grid>
      {activeStep === 0 && (
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}
        >
          <PrimaryButton
            onClick={handleNext}
            title={"Next"}
          />
        </Box>
      )}

      {activeStep === 1 && (
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}
        >
          <PrimaryButton
            onClick={() => setActiveStep(activeStep - 1)}
            title={"Back"}
          />
          <PrimaryButton
            onClick={handleNext}
            title={"Next"}
          />
        </Box>
      )}


      {activeStep === 2 && (
        <Box
          sx={{ display: "flex", justifyContent: "flex-end", mt: 4, gap: 2 }}
        >
          <PrimaryButton
            onClick={handleSaveDraft}
            title={"Save as Draft"}
            bgcolor={Colors.grey}
          />
          <PrimaryButton
            onClick={handleSubmitForm}
            title={"Submit"}
            loading={loader}
          />
        </Box>
      )}
    </Box>
  );
}

export default SupplierOnBoarding;